import ButtonComponent from '../../Basic/Button/Button.mjs';
import styled from 'styled-components';

const StyledModal = styled.div `
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: ${props => (props.isOpen ? 0 : '100%')};
  opacity: ${props => (props.isOpen ? 1 : 0)};
  transition-property: opacity, left;
  transition-duration: ${props => props.theme.animation.duration.gentle1};
  transition-timing-function: ${props => props.isOpen
    ? props.theme.animation.easing.expressive.entrance
    : props.theme.animation.easing.expressive.exit};
  padding: 3.5rem 1rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: ${props => props.theme.colors.backgroundColor};
  z-index: ${props => props.theme.zIndex.modal};
  box-sizing: border-box;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    padding: 3.5rem 4rem;
  }
`;
const StyledButton = styled(ButtonComponent) `
  width: 100%;
  max-width: 163px;
  padding: 0.5rem 0;
  gap: 0.25rem;

  svg {
    display: none;

    @media screen and (min-width: ${props => props.theme.breakpoints.xs}) {
      display: block;
    }
  }
`;
const StyledRegionsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 1.5rem;
  box-sizing: border-box;

  ${StyledButton} {
    &:nth-child(odd) {
      justify-self: end;
    }
    &:nth-child(even) {
      justify-self: start;
    }
  }
`;

export { StyledButton, StyledModal, StyledRegionsGrid };
//# sourceMappingURL=RegionSelectionModal.styles.mjs.map
